import React, { useContext, useRef, useState } from "react";
import { Alert, Grid, LinearProgress } from "@mui/material";
import stylesCss, { ButtonUpload, Column, Container, Tittle } from "../style";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Button } from "@mui/material";
import { ContactContext } from "../../../../../context/contact/ContactContext";
import { useTranslation } from "react-i18next";
import FileNotification from "../FilesNotification";
import { CssTextField } from "../../../style";

const StepFour = ({ setActiveStep }) => {
  const { t } = useTranslation();
  const classesSx = stylesCss;
  const uploadCertificadoAfilicionIESS = useRef(null);
  const [fileUploaded, setFileUploaded] = useState("");
  const [cedula, setCedula] = useState("");
  const [wait, setWait] = useState(false);
  const [alertDialog, setAlertDialog] = useState(false);
  const { createPrimaryContact, getBase64, company } =
    useContext(ContactContext);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 2);
  };

  const handleInformation = (e) => {
    setCedula(e.target.value);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleAssignPrimaryContact = async () => {
    setWait(true);
    if (fileUploaded === "" || cedula === "") {
      setAlertDialog(true);
    } else {
      const data = {
        fileUploaded: fileUploaded,
        cedula: cedula,
      };
      await Promise.all([createPrimaryContact(data)]);
      handleNext();
    }
    setWait(false);
  };
  const handleUpload = (e, tag) => {
    e.preventDefault();
    uploadCertificadoAfilicionIESS.current.click();
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    console.log(file);
    getBase64(file)
      .then((data) => {
        setFileUploaded(data);
      })
      .catch((error) => {
        alert("Error: " + error.currentTarget.error);
      });
  };
  console.log(cedula.length);
  return (
    <>
      {wait && <LinearProgress color="error" />}

      <FileNotification
        alertDialog={alertDialog}
        setAlertDialog={setAlertDialog}
      />
      <br />
      <Alert style={{ width: "100%", fontSize: "18px" }} severity="info">
        En caso de no contar con la información y/o documentación solicitada,
        por favor comunicarse a los contactos (593-2) 226-3805 / 226-3806 ext.
        1312, danny.prado@life.com.ec.
      </Alert>
      <Tittle>{t("generalInformation")}</Tittle>
      <Container>
        <Column>
          <CssTextField
            type={"text"}
            value={cedula}
            required={true}
            inputProps={{
              maxLength: 10,
            }}
            fullWidth
            label={t("identityCard")}
            id="cedula"
            name="cedula"
            onChange={(e) => handleInformation(e)}
          />
        </Column>
      </Container>
      <Tittle>{t("documentation")}</Tittle>
      <Container>
        <Column>
          <ButtonUpload onClick={(e) => handleUpload(e, 2)}>
            {t("certIees")}
            <UploadFileIcon />
          </ButtonUpload>
          <input
            type="file"
            accept="application/pdf"
            name={"certificadO_BANCARIO"}
            ref={uploadCertificadoAfilicionIESS}
            onChange={(e) => handleFileUpload(e)}
            style={{ display: "none" }}
          />
        </Column>
      </Container>
      <br />
      <br />
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12} md={12} lg={12}>
          <Grid container spacing={5}>
            <Grid
              item
              xs={6}
              md={6}
              lg={6}
              sx={{
                ...classesSx.gridBtnRegresar,
              }}
            >
              <Button
                sx={{ ...classesSx.btnBuscarRegresar }}
                variant="contained"
                onClick={handleBack}
              >
                {t("back")}
              </Button>
            </Grid>
            <Grid
              item
              xs={6}
              md={6}
              lg={6}
              sx={{
                ...classesSx.gridBtnContinuar,
              }}
            >
              {fileUploaded !== "" && cedula !== "" && cedula.length > 9 ? (
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  type="submit"
                  disabled={wait}
                  variant="contained"
                  onClick={handleAssignPrimaryContact}
                >
                  {t("submitApproval")}
                </Button>
              ) : (
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  type="submit"
                  variant="contained"
                  disabled={true}
                  onClick={handleAssignPrimaryContact}
                >
                  {t("submitApproval")}
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default StepFour;
